
import { z } from 'zod'

export const Language = {
  en: 'en-GB',
  nl: 'nl-NL',
} as const

export type Language = typeof Language[keyof typeof Language]

export const DEFAULT_LANGUAGE = Language.nl

export const supportedLangs = Object.values(Language)

// 'en' and 'nl' are also supported for backwards compatibility
export const LanguageSchema = z.enum([Language.en, Language.nl, 'en', 'nl'])

export const Organizations = {
  EyeCare: ['92'],
  'Hand and Wrist': ['73', '88'],
  Orthopaedics: ['89'],
  Proctology: ['79'],
  Velthuis: ['80'],
  Gynecology: ['105'],
  Urology: ['103'],
  Dermatology: ['102'],
}
